import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParentSubsidiaryDetailsComponent } from './parent-subsidiary-details/parent-subsidiary-details.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { CheckboxComponent } from '../../shared/checkbox/checkbox.component';

@NgModule({
  declarations: [
    ParentSubsidiaryDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    CheckboxComponent
  ]
})
export class CaxtonModule { }
